__turbopack_context__.v({
  "className": "lexend_69a3a6ab-module__jD94zW__className",
});
